import { classNames } from 'libs/react';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import { Text } from 'components/Text';
import { Icon } from 'components/Icon';
import './QuoteLink.scss';
/**
 * @component QuoteLink
 * @since 1.0.0
 */
export function QuoteLink(props) {
    const { value } = Object.assign({}, props);
    if (!value) {
        return null;
    }
    const className = classNames('quote-link', props.className);
    return (React.createElement(Fragment, null,
        React.createElement("div", { className: className },
            React.createElement("a", { href: value, target: "_blank", rel: "noreferrer" },
                React.createElement(Text, { value: t('View') }),
                React.createElement(Icon, { value: "external-link" })))));
}
